<div class="modal-header">
    <div class="modal-title">Create new version</div>

    <button id="add-interim-popup-close" type="button" class="close" aria-label="Close" (click)="decline()">
        <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body">
    <div class="row mb-3">
        <div class="col-md-12">
            <div class="label">Do you really want to create new Version of this Report?</div>
            <div>Your previous version will remain accessible on this page. You can return to review or download that previous report.</div>
            <input restrictFirstSpace type="text" class="input input__blue input__large mt-3"
                #versionName="ngModel" name="versionName" id="versionName"
                placeholder="e.g. Internal Evaluation, LLC" [(ngModel)]="NAME"
                maxlength="50" >
        </div>
    </div>
</div>

<div class="modal-footer h-auto">
    <button id="add-interim-popup-cancel" type="button" class="button secondary__button large__button position-static"
        (click)="decline()">Cancel</button>
    <button id="add-interim-popup-add" type="button" class="button primary__button large__button position-static"
        (click)="confirm()">Create new version</button>
</div>
